import React, { useEffect, useRef, useState } from "react";
import { KBD } from "../utils/Keybindings";
import { listen } from "../hooks/Listener";
import Alert from "../ui/Alert";
import TextButton from "../ui/TextButton";
import { kbdEvent } from "../utils/Utils";

export const XPLOR_STATUS_URL = "https://status.clearent.net/";

// Pinpad payment failure: [O]K (default) closes, [V]iew Xplor Status opens the status page without closing
export default function PaymentFailed(props) {
    const {
        controller = "",
        route = "",
        callback = () => { },
        title = "Payment Failed",
        description = "",
    } = props;

    const okRef = useRef(null);
    const statusRef = useRef(null);
    const [focusedIndex, setFocusedIndex] = useState(0);

    const viewStatus = () => {
        window.open(XPLOR_STATUS_URL, "_blank", "noopener,noreferrer");
    };

    useEffect(() => {
        const toggle = () => setFocusedIndex((prev) => (prev === 0 ? 1 : 0));
        const actions = [
            { key: KBD.ESCAPE, action: () => callback(false) },
            { key: KBD.O, action: () => callback(false) },
            { key: KBD.V, action: () => viewStatus() },
            { key: KBD.ARROW_LEFT, action: toggle },
            { key: KBD.ARROW_RIGHT, action: toggle },
            { key: KBD.TAB, action: (e) => { e.preventDefault(); toggle(); } },
            { key: KBD.SHIFT_TAB, action: (e) => { e.preventDefault(); toggle(); } },
        ];
        const cleanup = listen(controller, route, actions, false);
        return cleanup;
    }, [route]);

    useEffect(() => {
        // Wait a frame so the modal is mounted before taking focus
        const id = requestAnimationFrame(() => {
            (focusedIndex === 0 ? okRef : statusRef)?.current?.focus();
        });
        return () => cancelAnimationFrame(id);
    }, [focusedIndex]);

    return (
        <Alert
            title={title}
            dismissible
            callback={callback}
            description={
                <>
                    {description}
                    <div style={{ margin: "0 auto", textAlign: "center" }}>
                        <div className="shim" /><div className="shim" /><div className="shim" />
                        <TextButton ref={okRef} onClick={() => kbdEvent(KBD.O)}>
                            <strong>O</strong>K
                        </TextButton>
                        &nbsp;
                        <TextButton ref={statusRef} onClick={() => kbdEvent(KBD.V)}>
                            <strong>V</strong>iew Xplor Status
                        </TextButton>
                    </div>
                </>
            }
        />
    );
}
